module.exports = __webpack_public_path__ + "img/undraw_bus-stop.b0e92269.svg";